import hash from "object-hash";

import { Serializer } from "@megaron/serializers";

/**
 * Identifies the inputs that determine how a document type is constructed.
 *
 * Add dependencies that affect the produced document, such as a link tree,
 * after the serializer. Their order is significant.
 */
export const docTypeHash = <T>(serializer: Serializer<T>, ...dependencies: unknown[]): string =>
  hash({ schema: serializer.schema, dependencies, __version: 1 });
